import { useState } from "react"
import { Box, Typography, Button, Stack, useMediaQuery, IconButton } from "@mui/material"
import { FilterAltOff } from "@mui/icons-material"
import FilterListIcon from "@mui/icons-material/FilterList"
import { styled, useTheme } from "@mui/material/styles"
import SearchFilter from "./filters/SearchFilter"
import RangeFilter from "./filters/RangeFilter"
import TripleEXFilter from "./filters/TripleEXFilter"
import RefreshData from "./RefreshData"
import FiltersSheet from "./FiltersSheet"

const HeaderContainer = styled(Box)({
    gridColumn: '1 / 3',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
})

const LeftColumn = styled(Box)({
    width: '55%'
})

const RightColumn = styled(Box)({})

const Spacer = styled(Box)({
    flexGrow: 1
})

function Header({ setData, setLoading, loading, modifiers }) {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const { actions } = modifiers
    const [isFiltersOpen, setIsFiltersOpen] = useState(false)

    return (
        <HeaderContainer sx={{ 
            flexDirection: isMobile ? 'column' : 'row', 
            width: '100%', 
            mb: isMobile ? 1 : 0,
            gridColumn: isMobile ? '1' : '1 / 3'
        }}>
            <LeftColumn sx={{ width: isMobile ? '100%' : '55%' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: isMobile ? 1 : 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 500 }}>
                        Stock List
                    </Typography>
                    {isMobile && (
                        <RefreshData setData={setData} setLoading={setLoading} isMobile={isMobile} />
                    )}
                </Box>
                
                <Box sx={{ display: 'flex', gap: 1, mb: isMobile ? 0 : 2, width: '100%' }}>
                    <SearchFilter modifiers={modifiers} />
                    {isMobile && (
                        <IconButton 
                            onClick={() => setIsFiltersOpen(true)}
                            color="inherit"
                            sx={{ border: 1, borderColor: 'divider', borderRadius: 1 }}
                        >
                            <FilterListIcon />
                        </IconButton>
                    )}
                </Box>

                {!isMobile && (
                    <Stack direction="row" spacing={4} alignItems="center">
                        <RangeFilter selector='ct' modifiers={modifiers} loading={loading} />
                        <TripleEXFilter modifiers={modifiers} />

                        <Spacer />

                        <Button
                            color="inherit"
                            endIcon={<FilterAltOff />}
                            onClick={actions.reset}
                            sx={{ color: 'text.secondary', ml: 'auto' }}
                        >
                            RESET
                        </Button>
                    </Stack>
                )}
            </LeftColumn>

            {!isMobile && (
                <RightColumn>
                    <RefreshData setData={setData} setLoading={setLoading} isMobile={false} />
                </RightColumn>
            )}

            {isMobile && (
                <FiltersSheet 
                    open={isFiltersOpen} 
                    onClose={() => setIsFiltersOpen(false)} 
                    modifiers={modifiers} 
                    loading={loading}
                />
            )}
        </HeaderContainer>
    )
}

export default Header
